// extracted by mini-css-extract-plugin
export default {"contentBlock":"ContentBlock_contentBlock__DranG","body":"ContentBlock_body__eMx91"};